function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
import { parseHTMLSection } from "./CartUtils";
import CartAPI from "./CartAPI";
var MainCart = /*#__PURE__*/function (_HTMLElement) {
  function MainCart() {
    var _this;
    _classCallCheck(this, MainCart);
    _this = _callSuper(this, MainCart);
    _this.sidecart = document.querySelector('side-cart');
    _this.handleStickyWhenScrolling = function () {
      var stickyATC = _this.querySelector('.sticky-checkout');
      var mainProductButtons = _this.querySelector('.order-summary__buttons') || document.createElement('div');
      if (!stickyATC) {
        return;
      }
      window.addEventListener('scroll', function () {
        _this.toggleStickyATC(mainProductButtons, stickyATC);
      });
    };
    _this.cartAPI = CartAPI;
    _this.init();
    return _this;
  }
  _inherits(MainCart, _HTMLElement);
  return _createClass(MainCart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
      console.info('Main initialized');
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      this.initializeRemoveEvent();
      this.initializeUpdateEvent();
      this.handleStickyWhenScrolling();
    }
  }, {
    key: "updateCart",
    value: function updateCart(itemCount) {
      var _this2 = this;
      var sectionId = this.dataset.sectionId;
      try {
        fetch("/cart?sections=main-cart&section_id=".concat(sectionId), {
          method: 'GET',
          headers: {
            contentType: 'application/json'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (responseJson) {
          _this2.renderNewCart(responseJson['main-cart'], itemCount);
        });
      } catch (error) {}
    }
  }, {
    key: "initializeRemoveEvent",
    value: function initializeRemoveEvent() {
      var _this3 = this;
      var buttons = this.querySelectorAll('.cart-item__remove');
      buttons.forEach(function (button) {
        button.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(evt) {
            var item, formData, result, sections, itemsCount, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  evt.preventDefault();
                  console.info('Remove from cart clicked');
                  item = button.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: 0,
                    sections: 'main-cart,ajax-side-cart,ajax-cart-icon'
                  };
                  if (!formData) {
                    _context.n = 4;
                    break;
                  }
                  _context.p = 1;
                  _context.n = 2;
                  return _this3.cartAPI.removeFromCart(formData);
                case 2:
                  result = _context.v;
                  console.info('Item removed from cart:', result);
                  sections = result['sections'];
                  itemsCount = result['item_count'];
                  _this3.renderHTML(sections, itemsCount);
                  _context.n = 4;
                  break;
                case 3:
                  _context.p = 3;
                  _t = _context.v;
                  console.error('Failed to remove item from cart:', _t);
                case 4:
                  return _context.a(2);
              }
            }, _callee, null, [[1, 3]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeUpdateEvent",
    value: function initializeUpdateEvent() {
      var _this4 = this;
      var inputs = this.querySelectorAll('.cart-item__quantity-input');
      inputs.forEach(function (input) {
        var inputElement = input;
        inputElement.addEventListener('change', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(evt) {
            var item, formData, result, sections, itemsCount, _t2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  evt.preventDefault();
                  console.info('Update cart item');
                  item = inputElement.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: inputElement.value,
                    sections: 'main-cart,ajax-side-cart,ajax-cart-icon'
                  };
                  if (!formData) {
                    _context2.n = 4;
                    break;
                  }
                  _context2.p = 1;
                  _context2.n = 2;
                  return _this4.cartAPI.updateItemCart(formData);
                case 2:
                  result = _context2.v;
                  console.info('Cart item updated:', result);
                  sections = result['sections'];
                  itemsCount = result['item_count'];
                  _this4.renderHTML(sections, itemsCount);
                  _context2.n = 4;
                  break;
                case 3:
                  _context2.p = 3;
                  _t2 = _context2.v;
                  console.error('Failed to update cart item:', _t2);
                case 4:
                  return _context2.a(2);
              }
            }, _callee2, null, [[1, 3]]);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "renderNewCart",
    value: function renderNewCart(newCart, itemCount) {
      var _newMainCart$querySel, _newMainCart$querySel2, _newMainCart$querySel3, _newMainCart$querySel4;
      var newMainCart = parseHTMLSection(newCart);
      var mainCart = document.querySelector('main-cart');
      var cartItems = document.querySelector('.main-cart__items') || document.createElement('div');
      var cartGamification = document.querySelector('.main-cart__gammification') || document.createElement('div');
      var subtotal = document.querySelector('.order-summary__values') || document.createElement('div');
      var checkoutButtons = document.querySelector('.order-summary__buttons') || document.createElement('div');
      if (!mainCart) {
        console.error("Main Cart is not found.");
        return;
      }
      cartItems.innerHTML = ((_newMainCart$querySel = newMainCart.querySelector('.main-cart__items')) === null || _newMainCart$querySel === void 0 ? void 0 : _newMainCart$querySel.innerHTML) || '';
      cartGamification.innerHTML = ((_newMainCart$querySel2 = newMainCart.querySelector('.main-cart__gammification')) === null || _newMainCart$querySel2 === void 0 ? void 0 : _newMainCart$querySel2.innerHTML) || '';
      subtotal.innerHTML = ((_newMainCart$querySel3 = newMainCart.querySelector('.order-summary__values')) === null || _newMainCart$querySel3 === void 0 ? void 0 : _newMainCart$querySel3.innerHTML) || '';
      checkoutButtons.innerHTML = ((_newMainCart$querySel4 = newMainCart.querySelector('.order-summary__buttons')) === null || _newMainCart$querySel4 === void 0 ? void 0 : _newMainCart$querySel4.innerHTML) || '';
      if (itemCount == 0) {
        var _mainCart$querySelect;
        (_mainCart$querySelect = mainCart.querySelector('.order-summary__express-checkout')) === null || _mainCart$querySelect === void 0 || _mainCart$querySelect.classList.add('visually-hidden');
      }
    }
  }, {
    key: "renderHTML",
    value: function renderHTML(sections, itemCount) {
      var _this$sidecart;
      var HTMLSection = parseHTMLSection(sections['ajax-side-cart']);
      var sideCart = document.querySelector('side-cart');
      if (!sideCart) {
        console.error('No se encontró el elemento "side-cart".');
        return;
      }
      sideCart.innerHTML = '';
      sideCart === null || sideCart === void 0 || sideCart.appendChild(HTMLSection);
      this.initializeUpdateEvent();
      this.initializeRemoveEvent();
      var newCartIcon = parseHTMLSection(sections['ajax-cart-icon']);
      var cartIcon = document.querySelector('#side-cart-button');
      if (!cartIcon) {
        console.error('No se encontró el elemento "cart-icon".');
        return;
      }
      cartIcon.innerHTML = '';
      cartIcon === null || cartIcon === void 0 || cartIcon.appendChild(newCartIcon);
      this.renderNewCart(sections['main-cart'], itemCount);
      console.info('Cart updated.');
      (_this$sidecart = this.sidecart) === null || _this$sidecart === void 0 || _this$sidecart.setupEventListeners();
      this.setupEventListeners();
      return;
    }
  }, {
    key: "verifyIsVisible",
    value: function verifyIsVisible(element) {
      var item = element.getBoundingClientRect();
      return item.top >= 0 && item.left >= 0 && item.bottom <= (window.innerHeight || document.documentElement.clientHeight) && item.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }, {
    key: "toggleStickyATC",
    value: function toggleStickyATC(reference, sticky) {
      if (this.verifyIsVisible(reference)) {
        sticky.classList.remove('visible');
      } else {
        sticky.classList.add('visible');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default MainCart;